/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import { IconContext } from 'react-icons';
import { GrLocation, GrFormDown } from 'react-icons/gr';
import { ImArrowLeft2 } from 'react-icons/im';

import { formatCurrency } from '../../utils';

// ========= action import section ========= //
import {
  historyPayments,
  historyPaymentsCompleted,
  historyPaymentsProcessed,
} from '../../actions/dashboardAction';
import { doFetchOfferPending } from '../../actions/offerAction';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataHistoryInterface, {
  PembelianInterface,
} from '../../interface/reducers/history';
import AuthInterface, {
  UserCurrencyInterface,
} from '../../interface/reducers/auth';
import RouteHistoryInterface from '../../interface/router';
import Offer from './BuyingTabs/Offer';
import Pending from './BuyingTabs/Pending';
import InProgress from './BuyingTabs/InProgress';
import History from './BuyingTabs/History';
import DataCategoryInterface from '../../interface/reducers/category';
import DataUIInterface from '../../interface/reducers/ui';
import {
  doResetDashboardFilter,
  setDashboardStatus,
} from '../../actions/uiAction';
import {
  getHistoryShipping,
  setDefaultAddress,
} from '../../actions/postalCodeAction';
import DataPostalCodeInterface, {
  CountriesInterface,
  ShippingHistoryInterface,
} from '../../interface/reducers/postalCode';
import ModalAddressBookV3 from '../Modals/ModalAddressBookV3';
// ====== end of interface import section ====== //

import REVENUE_IMG from '../../images/rev1024.png';
import SALES_IMG from '../../images/sales1024.png';
import STATUS_IMG from '../../images/status1024.png';

type getDataType = {
  keyword?: string;
  sort_by?: string;
  category?: string;
};

type stateToProps = {
  dataHistory: DataHistoryInterface;
  dataAuth: AuthInterface;
  dataCategory: DataCategoryInterface;
  dataUi: DataUIInterface;
  dataPostalCode: DataPostalCodeInterface;
};

interface orderSaya extends stateToProps, UserCurrencyInterface {
  history: RouteHistoryInterface;
  routes: any;
  doHistory: (params: getDataType) => any;
  doFetchOffer: (params: getDataType) => any;
  doHistoryCompleted: (params: getDataType) => any;
  doHistoryProcessed: (params: getDataType) => any;
  doResetFilter: () => Promise<any>;
  doFetchHistoryShipping: () => Promise<any>;
  changeAddressDefault: (payload: any) => Promise<any>;
  pembelian: PembelianInterface;
  dataAddress: ShippingHistoryInterface[];
  countries: CountriesInterface[];
}

/**
 * Buying User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {orderSaya} props for this component.
 * @return {JSX.Element}
 */
function OrderSaya({
  history,
  routes,
  dataAuth,
  doHistory,
  dataCategory,
  doFetchOffer,
  doHistoryProcessed,
  doHistoryCompleted,
  pembelian,
  ratio,
  currency,
  dataUi,
  doResetFilter,
  doFetchHistoryShipping,
  dataAddress,
  countries,
  dataPostalCode,
  changeAddressDefault,
}: orderSaya): JSX.Element {
  const [status, setStatus] = useState('pending');
  const [firstRender, setFirstRender] = useState(true);
  const [isGettingData, setGettingData] = useState(false);
  const [TABS, setTabs] = useState([
    'Offer',
    'Pending',
    'In Progress',
    'History',
  ]);
  const [activeTabs, setActiveTabs] = useState(TABS[0]);

  useEffect(() => {
    if (dataAuth.userdata.country_code !== 'IDN') {
      setTabs(['Pending', 'In Progress', 'History']);
      setActiveTabs(TABS[0]);
    } else {
      setTabs(['Offer', 'Pending', 'In Progress', 'History']);
    }
  }, [dataAuth.userdata]);

  let payloadForGetData = {
    keyword: dataUi.userDashboardKeyword,
    sort_by: dataUi.userDashboardSort,
    category: dataUi.userDashboardCategory,
    status,
    order_status: dataUi.userDashboardStatus,
    page: dataUi.userDashboardPage,
  };

  // Will be called every time this component is mounted
  useEffect(() => {
    doFetchHistoryShipping();
    doHistory(payloadForGetData);
    setFirstRender(false);
    if (history?.location?.state?.tabs) {
      setActiveTabs(history?.location?.state?.tabs);
    }
  }, []);

  // for handling address book modal
  const [isOpenedAddressBookModal, setOpenedAddressBookModal] = useState(false);
  const [isAddressButtonDisable, setIsAddressButtonDisable] = useState(false);
  const [shippingId, setShippingId] = useState<number | null>(null);
  const [defaultId, setDefaultId] = useState<number | null>(0);
  const toggleAddressBookModal = () => {
    setOpenedAddressBookModal(!isOpenedAddressBookModal);
  };
  useEffect(() => {
    if (dataAddress.length) {
      setShippingId(dataAddress[0].id);
    }
  }, [dataAddress]);
  const changeId = (id: number) => {
    setIsAddressButtonDisable(true);
    setShippingId(id);
  };
  const submitShipping = async () => {
    setIsAddressButtonDisable(false);
    setDefaultId(shippingId);
    changeAddressDefault(shippingId).then(() => {
      setShippingId(0);
      setDefaultId(0);
      doFetchHistoryShipping().then(() => {
        toggleAddressBookModal();
      });
    });
  };

  const doGetData = () => {
    payloadForGetData = {
      keyword: dataUi.userDashboardKeyword,
      sort_by: dataUi.userDashboardSort,
      category: dataUi.userDashboardCategory,
      status,
      order_status: dataUi.userDashboardStatus,
      page: dataUi.userDashboardPage,
    };
    setGettingData(true);
    switch (activeTabs) {
      case 'Offer':
        doFetchOffer(payloadForGetData).then(() => {
          setTimeout(() => setGettingData(false), 1500);
        });
        break;
      case 'Pending':
        doHistory(payloadForGetData).then(() => {
          setTimeout(() => setGettingData(false), 1500);
        });
        break;
      case 'In Progress':
        doHistoryProcessed(payloadForGetData).then(() => {
          setTimeout(() => setGettingData(false), 1500);
        });
        break;
      case 'History':
        doHistoryCompleted(payloadForGetData).then(() => {
          setTimeout(() => setGettingData(false), 1500);
        });
        break;
      default:
        break;
    }
  };

  // Will be called every time ui reducer change to update payload for sort and filter list data
  useEffect(() => {
    doGetData();
  }, [
    dataUi.userDashboardCategory,
    dataUi.userDashboardKeyword,
    dataUi.userDashboardSort,
    dataUi.userDashboardStatus,
    dataUi.userDashboardPage,
  ]);

  useEffect(() => {
    if (!firstRender) doResetFilter();
    if (!firstRender && !isGettingData) doGetData();
  }, [status, activeTabs]);

  /**
   * Function for handling tab changes
   * @param {string} targetTab target tab for changing to active.
   */
  function handleChangeTabs(targetTab: string) {
    setActiveTabs(targetTab);
    if (targetTab === 'In Progress') {
      setStatus('processed');
    } else if (targetTab === 'History') {
      setStatus('history');
    } else {
      setStatus('pending');
    }
  }

  /**
   * Function for formatting the total transactions value
   * @param {PembelianInterface} transaction data.
   * @return {string} formatted currency
   */
  function _totalTransaction(
    { total_transaction }: PembelianInterface,
    ratio,
    currency,
  ) {
    if (!total_transaction) return '-';

    return formatCurrency(total_transaction, ratio, currency);
  }

  /**
   * Function for rendering tabs data
   * @param {string} currentActiveTab current active tab from state.
   * @return {JSX.Element} react element
   */
  function renderTabContent(currentActiveTab: string) {
    switch (currentActiveTab) {
      case 'Offer':
        return (
          <Offer
            callbackAfterUpdate={callbackAfterUpdateOffer}
            loading={isGettingData}
          />
        );
      case 'Pending':
        return (
          <Pending
            callbackAfterUpdate={callbackAfterUpdatePending}
            loading={isGettingData}
          />
        );
      case 'In Progress':
        return (
          <InProgress
            callbackAfterUpdate={callbackAfterUpdateProgress}
            loading={isGettingData}
          />
        );
      case 'History':
        return (
          <History
            callbackAfterUpdate={callbackAfterUpdateHistory}
            loading={isGettingData}
          />
        );
      default:
        return;
    }
  }

  const callbackAfterUpdateOffer = () => {
    doFetchOffer(payloadForGetData);
  };

  const callbackAfterUpdatePending = () => {
    doHistory(payloadForGetData);
  };

  const callbackAfterUpdateProgress = () => {
    doHistoryProcessed(payloadForGetData);
  };

  const callbackAfterUpdateHistory = () => {
    doHistoryCompleted(payloadForGetData);
  };

  const onClickBack = () => {
    history.push({ pathname: `/user_dashboard` });
  };

  const countryFromAddress = dataAddress.length && dataAddress[0].country;
  const userCountry = countries.length
    ? countries.find((t) => t.code3 === countryFromAddress)
      ? countries.find((t) => t.code3 === countryFromAddress).name
      : '-'
    : '-';

  return (
    <div className={'buying-container'}>
      <div className={'title-container'}>
        <div className={'back-button'} onClick={onClickBack}>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <ImArrowLeft2 />
            </div>
          </IconContext.Provider>
        </div>
        <span className={'title'}>Buying Dashboard</span>
        <div className={'shipping-container'} onClick={toggleAddressBookModal}>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <GrLocation />
            </div>
          </IconContext.Provider>
          <span className={'ship-to'}>
            Ship to
            <span className={'ship-to-location'}>
              {`${dataAddress.length ? dataAddress[0]?.alias : '-'} - ${
                dataAddress[0]?.full_name ? dataAddress[0]?.full_name : '-'
              }`}
            </span>
          </span>
          <IconContext.Provider value={{ color: '#242424', size: '10px' }}>
            <div>
              <GrFormDown />
            </div>
          </IconContext.Provider>
        </div>
      </div>

      <div className={'info-container'}>
        <div className={'info-box'}>
          <KickImage src={REVENUE_IMG} className={'icon'} />
          <p className={'title'}>Total Purchase</p>
          <p className={'value'}>
            {_totalTransaction(
              pembelian,
              dataAuth.userCurrency.ratio,
              dataAuth.userCurrency.currency,
            )}
          </p>
        </div>
        <div className={'info-box'}>
          <KickImage src={SALES_IMG} className={'icon'} />
          <p className={'title'}>Successful Transaction</p>
          <p className={'value'}>
            {pembelian.success_transaction
              ? pembelian.success_transaction
              : '-'}
          </p>
        </div>
        <div className={'info-box'}>
          <KickImage src={STATUS_IMG} className={'icon'} />
          <p className={'title'}>Buyer Status</p>
          <p className={'value'}>Excellent</p>
        </div>
      </div>

      <div className={'tab-container'}>
        {TABS.map((t) => {
          let classDiv = 'tabs';
          if (activeTabs === t) classDiv += ' active';
          return (
            <div
              key={t}
              className={classDiv}
              onClick={() => handleChangeTabs(t)}
            >
              <p>{t}</p>
              {activeTabs === t && <div className={'is-active-tabs'} />}
            </div>
          );
        })}
      </div>

      <div className={'tab-content'}>{renderTabContent(activeTabs)}</div>

      <ModalAddressBookV3
        isOpen={isOpenedAddressBookModal}
        onToggle={toggleAddressBookModal}
        dataAddress={dataPostalCode.shippingHistory.data}
        countries={dataPostalCode.countries.data}
        provinces={dataPostalCode.provinces.data}
        cities={dataPostalCode.cities.data}
        id={shippingId}
        changeId={changeId}
        defaultId={defaultId}
        submitShipping={submitShipping}
        getHistoryShipping={doFetchHistoryShipping}
        isModalOffer={true}
        isAddressButtonDisable={isAddressButtonDisable}
        modalTitle={'Change Default Address'}
        type={'set-default'}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataAuth: state.dataAuth,
    pembelian: state.dataHistory.pembelian,
    ratio: state.dataAuth.userCurrency.ratio,
    currency: state.dataAuth.userCurrency.currency,
    dataCategory: state.dataCategory,
    dataUi: state.dataUi,
    dataAddress: state.dataPostalCode.shippingHistory.data,
    countries: state.dataPostalCode.countries.data,
    dataPostalCode: state.dataPostalCode,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doHistory: (query: getDataType) => dispatch(historyPayments(query)),
    doFetchOffer: (query: getDataType) => dispatch(doFetchOfferPending(query)),
    doHistoryProcessed: (query: getDataType) =>
      dispatch(historyPaymentsProcessed(query)),
    doHistoryCompleted: (query: getDataType) =>
      dispatch(historyPaymentsCompleted(query)),
    doResetFilter: () => dispatch(doResetDashboardFilter()),
    doFetchHistoryShipping: () => dispatch(getHistoryShipping()),
    changeAddressDefault: (payload: any) =>
      dispatch(setDefaultAddress(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSaya);
